import { render, staticRenderFns } from "./ChatView.vue?vue&type=template&id=0dd43c3f&scoped=true&"
import script from "./ChatView.vue?vue&type=script&lang=ts&"
export * from "./ChatView.vue?vue&type=script&lang=ts&"
import style0 from "./ChatView.vue?vue&type=style&index=0&id=0dd43c3f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd43c3f",
  null
  
)

export default component.exports